import { useContext, useEffect } from 'react';
import { SocketContext } from '../contexts/SocketProvider';
import { selectUser, setProfile } from '../store/profile/profileSlice';
import { useAppDispatch, useAppSelector } from './redux';
import { useSocketEmit } from './useSocketEmit';

const useProfile = () => {
  const { socketReady } = useContext(SocketContext);
  const { getProfile } = useSocketEmit();
  const profile = useAppSelector(selectUser);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (socketReady && !profile?.id) {
      refreshProfile();
    }
  }, [socketReady]);

  const refreshProfile = () => {
    getProfile()
      .then((response) => {
        dispatch(setProfile(response));
      })
      .catch((err) => console.warn(err?.message));
  };

  return {
    refreshProfile,
    profile,
  };
};

export default useProfile;
